import styled from 'styled-components'

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	> button {
		align-self: flex-end;
	}

	.table-container {
		width: calc(100% - 16px);
	}
`
